module.exports = __webpack_public_path__ + "img/ensure-vanilla.cf3a2ed6.jpg";